import React from "react";
import { useScenario, usePermissions } from "../hooks/api-client.js";
import ExplicitConsents from "./explicit-consents/explicit-consents.js";
import ImplicitConsents from "./implicit-consents/implicit-consents.js";
const PERMISSIONS_REQUIRED_SCENARIOS = ["account-optin", "account-optout"];
const Consents = ({ implicit, explicit, scenarioType }) => {
  const REQUIRED_SCENARIOS = [scenarioType];
  const permissionsRequired = PERMISSIONS_REQUIRED_SCENARIOS.includes(scenarioType);
  const scenarios = permissionsRequired ? PERMISSIONS_REQUIRED_SCENARIOS : REQUIRED_SCENARIOS;
  const [scenarioWrapper] = scenarios.map((type) => useScenario(type));
  const { scenario } = scenarioWrapper;
  const permissionsWrapper = usePermissions(permissionsRequired);
  const { permissions } = permissionsWrapper;
  const { onChange } = permissionsRequired ? permissionsWrapper : scenarioWrapper;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, explicit && /* @__PURE__ */ React.createElement(
    ExplicitConsents,
    {
      documents: scenario.explicitDocuments,
      onChange,
      permissions,
      scenarioType
    }
  ), implicit && /* @__PURE__ */ React.createElement(ImplicitConsents, { documents: scenario.implicitDocuments }));
};
export {
  Consents as default
};
//# sourceMappingURL=consents.js.map
